import(/* webpackMode: "eager" */ "/vercel/path0/app/fake-name-generator/page.tsx");
